import { Component, OnInit, Input } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { LangService } from "src/app/services/lang/lang.service";
import { WinService } from "src/app/services/win.service";
import { Router, ActivatedRoute } from "@angular/router";
import { SessionService } from "src/app/services/session.service";
import { OrderService } from "src/app/services/api/order.service";
import { ProductService } from "src/app/services/api/product.service";
import { ArtworkComponent } from "src/app/components/modals/artwork/artwork.component";
import { PaymentComponent } from "src/app/components/modals/payment/payment.component";
import { CartService } from "src/app/services/api/cart.service";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { LoginComponent } from "src/app/components/modals/login/login.component";
import { CustomerService } from "src/app/services/api/customer.service";

import { CuttingTypeComponent } from "src/app/components/modals/product/options/cutting-type/cutting-type.component";
import { MessageComponent } from "src/app/components/modals/message/message.component";

import { SocketioService } from "src/app/services/socketio.service";
import { TshirtArtworkComponent } from 'src/app/components/modals/tshirt-artwork/tshirt-artwork.component';
import { TotebagArtworkComponent } from 'src/app/components/modals/totebag-artwork/totebag-artwork.component';
import { ApproveartworkComponent } from "src/app/components/modals/approveartwork/approveartwork.component";
import { WalletService } from "src/app/services/api/wallet.service";
import { ImageLazyLoad } from "src/app/services/api/files.service";
import { ConfirmationmodalComponent } from "src/app/components/modals/confirmationmodal/confirmationmodal.component";
import { ChangeorderrequestComponent } from "src/app/components/modals/changeorderrequest/changeorderrequest.component";


@Component({
  selector: "app-summary",
  templateUrl: "./summary.component.html",
  styleUrls: ["./summary.component.scss"],
})
export class SummaryComponent implements OnInit {
	orderId: any;

	@Input() product: any = null;
	/* list of order items */

	order: any = null;
	orderItems: any = null;
	isAllItemHasAttachment: any = true;
	reviews: any = null;
	loadMoreBtn: boolean = true;
	isOrder: any = true;

	modalRef: BsModalRef;
	/* customPrice: any = null; */

	statusComments: any = {};

	voucherCode = '';
	voucherDiscountAmount:any = 0;
	itemDiscountTotal:any = 0;

	quickViewImage = '';
	isApproveAttachmentConfirm = false;

	remainingBalance = 0;

	constructor(
		public winService: WinService,
		public lang: LangService,
		public title: Title,
		public sessionService: SessionService,
		public router: Router,
		public orderService: OrderService,
		public productService: ProductService,
		public modalService: BsModalService,
		public cartService: CartService,
		public activeRoute: ActivatedRoute,
		public _route: ActivatedRoute,
		public customerService: CustomerService,
		public socketioService: SocketioService,
		public walletService: WalletService
	) {}

	ngOnInit() {
		this.title.setTitle("Order Summary");
		if (!this.sessionService.user.isLogedIn) {
			let config: ModalOptions = {
				backdrop: "static",
				keyboard: false,
				animated: true,
				ignoreBackdropClick: true,
				initialState: {},
			};
			this.modalRef = this.modalService.show(LoginComponent, config);
			this.modalRef.setClass("login-modal modal-dialog-centered");
			this.modalRef.content.onClose = (myData:any) => {
				this.modalRef.hide();
				if (myData.forceClose) {
					this.router.navigate(["/"]);
				} else {
					setTimeout((f) => {
						this.ngOnInit();
					}, 1000);
				}
			};
		} else {
			this.order = null;
			this.orderItems = null;

			this.activeRoute.paramMap.subscribe((urlParam) => {
				this.orderId = urlParam.get("orderId");
				this.orderService.getOrder(this.orderId).then((order) => {
					if (order) {

						let o: any = order;
						let sd: any = o.shipping_description.split(" - ");
						o.shipping_description2 = o.shipping_description;
						if (typeof sd[0] != "undefined") {
							o.shipping_description2 = sd[0];
						}
						this.order = o;

						/** start not needed any more */
							// let sa = this.order.extension_attributes.shipping_assignments;
							// sa.forEach((shipping) => {
							// 	o.shipping_method = shipping.shipping.method;
							// });

							// let url = "/rest/entrelable/V1/lns-api/shipment/" + this.order.entity_id;
							// this.productService.makeRequest(url, "", "GET").then((shipment) => {
							// 	let s: any = shipment;
							// 	this.order["shipment"] = s;

							// 	if (s.length > 0) {
							// 		let tracks = [];
							// 		s.forEach((shipment) => {
							// 			if (shipment.tracks.length > 0) {
							// 				shipment.tracks.forEach((track) => {
							// 					let hashTrack = btoa(
							// 						track.track_number + "hashlbcexpress"
							// 					);

							// 					let title = track.title.toLowerCase();
							// 					if (title == "lbc") {
							// 						track.carrier_code = "lbc";
							// 					}

							// 					tracks.push({
							// 						carrier_code: track.carrier_code,
							// 						title: track.title,
							// 						track_number: track.track_number,
							// 						hash_track: hashTrack,
							// 					});
							// 				});
							// 			}
							// 		});
							// 		if (tracks.length) {
							// 			this.order["shipment_tracks"] = tracks;
							// 		}
							// 	}
							// });
						/** end not needed any more */
						
						/** 
						 * hold the parent item id
						 * so that we can check if there are 2 or mor entrie in the order child items
						 * we will only take the first item in row
						 */
						let parentItemId:any = [];

						this.itemDiscountTotal = 0;
						o.items.forEach((item:any) => {

							if(item.sku.match(/custom-t-shirt/gi)){
								item.sku = 'custom-t-shirt';
								item.parent_item = item;
							}
							if(item.sku.match(/custom-canvas-tote-bag/gi)){
								item.sku = 'custom-canvas-tote-bag';
								item.parent_item = item;
							}

							if (item.parent_item) {
								if(!this.orderService.inArray(item.parent_item.item_id, parentItemId)){
									parentItemId.push(item.parent_item.item_id);
		
									let sku = item.sku;
									sku = sku.replace("-" + item.name, "");
									//---- item.attachment = null;
		
									this.itemDiscountTotal += item.parent_item.discount_amount;
		
									//---- this.getAttachment(item, true);
		
									item["cart"] = {
										item_id: item.quote_item_id,
									};
									// /* this.cartService.getItemInfo(item); */
									//---- item.parent_item.discounted_price_pp =
									//---- item.parent_item.base_price - item.parent_item.base_price * (item.parent_item.discount_percent / 100);
		
									// item.parent_item.discount_percent = parseInt(item.parent_item.discount_percent);
									//---- if (item.parent_item.discount_percent > 0) {
									//---- 	item.parent_item["discounted_price"] = item.parent_item.base_price - item.parent_item.base_price * (item.parent_item.discount_percent / 100);
									//---- }

									//---- if(typeof item.parent_item['additional_data'] != 'undefined'){
									//---- 	try {
									//---- 		item.parent_item['additional_data'] = JSON.parse(item.parent_item['additional_data']);
									//---- 		item.parent_item['additional_data']['sticker_pad'] = item.parent_item['additional_data']['sticker_pad'] + ''; /** make string */
									//---- 	} catch (error) {
									//---- 		/** do nothing */
									//---- 	}
									//---- }
									
									//---- this.productService.getProductBySku(sku).then((perProd) => {
										//---- let product: any = item["product"];
		
										let custom_options = item.parent_item.product_option.extension_attributes.custom_options;

										item['custom_options'] = [];
										custom_options.forEach((option:any, key:any) => {
											if(sku == 'custom-t-shirt'){ /** for t-shirt */
												custom_options[key]['title'] = option.title;
												if(option.title == 'Color'){
													custom_options[key]['option_value'] = this.getOptionValueTitle(option, custom_options[key]);
													custom_options[key]['option_value'] = custom_options[key]['option_value'].split('-');
													custom_options[key]['option_value'] = custom_options[key]['option_value'][0];
													item['custom_options'].push(custom_options[key]);
												}
												else if(option.title == 'Print Location'){
													custom_options[key]['option_value'] = this.getOptionValueTitle(option, custom_options[key]);
													item['custom_options'].push(custom_options[key]);
												}
												else if(this.cartService.inArray(option.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
													if(custom_options[key]['option_value']){
														custom_options[key]['title']  = option.title.replace('-', ' Qty ');
														item['custom_options'].push(custom_options[key]);
													}
												}
												else if(this.cartService.inArray(option.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
													custom_options[key]['title']  = option.title;
													item['custom_options'].push(custom_options[key]);
												}
											}
											else if(sku == 'custom-canvas-tote-bag'){
												custom_options[key]['title'] = option.title;

												if(option.title == 'Sizes' || option.title == 'Print Location'){
													custom_options[key]['option_value'] = this.getOptionValueTitle(option, custom_options[key]);
													item['custom_options'].push(custom_options[key]);
												}
												else if(option.title == 'Front Print Size' || option.title == 'Back Print Size'){
													item['custom_options'].push(custom_options[key]);
												}
											}
											else {
												if(option.title == 'custom size'){
													custom_options[key]['title'] = 'size';
													let coSize = custom_options[key]['option_value'].split(' x ');
													if(coSize.length == 2){
														custom_options[key]['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
													}
													item['custom_options'].push(custom_options[key]);
												}
												else if(option.title == 'adhesive'){
													custom_options[key]['title'] = option.title;
													item['custom_options'].push(custom_options[key]);
												}
												else if(option.title == 'cutting type'){
													custom_options[key]['title'] = option.title;
													item['custom_options'].push(custom_options[key]);
													
													custom_options[key].values.forEach((optVal:any) => {
														if(optVal.option_type_id + '' == custom_options[key]['option_value']){
															custom_options[key]['option_value'] = optVal.title;
														}
													});
												}
											}












											//---- opts.forEach(opt => {
											//---- 	if(parseInt(option.option_id) == opt.option_id){
											//---- 		if(opt.product_sku == 'custom-t-shirt'){ /** for t-shirt */
											//---- 			custom_options[key]['title'] = opt.title;
											//---- 			if(opt.title == 'Color'){
											//---- 				custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
											//---- 				custom_options[key]['option_value'] = custom_options[key]['option_value'].split('-');
											//---- 				custom_options[key]['option_value'] = custom_options[key]['option_value'][0];
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 			else if(opt.title == 'Print Location'){
											//---- 				custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 			else if(this.cartService.inArray(opt.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
											//---- 				if(custom_options[key]['option_value']){
											//---- 					custom_options[key]['title']  = opt.title.replace('-', ' Qty ');
											//---- 					item['custom_options'].push(custom_options[key]);
											//---- 				}
											//---- 			}
											//---- 			else if(this.cartService.inArray(opt.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
											//---- 				custom_options[key]['title']  = opt.title;
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 		}
											//---- 		else if(opt.product_sku == 'custom-canvas-tote-bag'){
											//---- 			custom_options[key]['title'] = opt.title;

											//---- 			if(opt.title == 'Sizes' || opt.title == 'Print Location'){
											//---- 				custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 			else if(opt.title == 'Front Print Size' || opt.title == 'Back Print Size'){
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 		}
											//---- 		else {
											//---- 			if(opt.title == 'custom size'){
											//---- 				custom_options[key]['title'] = 'size';
											//---- 				let coSize = custom_options[key]['option_value'].split(' x ');
											//---- 				if(coSize.length == 2){
											//---- 					custom_options[key]['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
											//---- 				}
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 			else if(opt.title == 'adhesive'){
											//---- 				custom_options[key]['title'] = opt.title;
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 			}
											//---- 			else if(opt.title == 'cutting type'){
											//---- 				custom_options[key]['title'] = opt.title;
											//---- 				item['custom_options'].push(custom_options[key]);
											//---- 				opt.values.forEach(optVal => {
											//---- 					if(optVal.option_type_id + '' == custom_options[key]['option_value']){
											//---- 						custom_options[key]['option_value'] = optVal.title;
											//---- 					}
											//---- 				});
											//---- 			}
											//---- 		}
											//---- 	}
											//---- });
										});
									//---- });
										
									//---- this.productService.getProductImage(item.parent_item.product_id, 150, 150).then((pImage) => {
										//---- if (pImage) {
										//---- 	item.parent_item["images"] = pImage;
										//---- }
									//---- });
		
									//---- if (!this.orderItems) {
									//---- 	this.orderItems = [item];
									//---- } else {
									//---- 	this.orderItems.push(item);
									//---- }
								}
							}
						});

						this.orderItems = o.items;

						if(typeof o['coupon_code'] != 'undefined'){
							this.voucherCode = o['coupon_code'];
							this.voucherDiscountAmount = o.discount_amount - this.itemDiscountTotal;
						} else {
							this.voucherCode = '';
							this.voucherDiscountAmount = 0;
						}
						
						// this.socketCallBack();

						this.walletService.getWallet();

						let totalPayment = 0;
						this.order.extension_attributes.hnd_payment_history.forEach(hnd_payment_history => {
							totalPayment += parseFloat(hnd_payment_history.amount_paid);
						});
						this.remainingBalance = this.order.grand_total - totalPayment;

						
						// this.orderService.makeRequest('/rest/entrelable/V1/hnd-order/order/address/'+this.order.entity_id, null, 'GET').then((resolve:any) => {
						// 	this.order.addresses = resolve;
						// });
					} else {
						this.router.navigate(["/"]);
					}
				});
			});
		}
	}

	getOptionValueTitle(opt:any, co:any){
		let title:any = [];
		opt.values.forEach((optValue:any) => {
			let op = co.option_value + "";
			let coOptionValues = op.split(',');
			coOptionValues.forEach((coOptionValue:any) => {
				if(coOptionValue + '' ==  optValue.option_type_id + '' ){
					title.push(optValue.title);
				}
			});
		});
		return title.join(', ');
	}

	socketCallBack(){
		this.socketioService.joinOrderRoom(this.order.entity_id);
		// this.socketioService.addCallback('order_saved', 'order_summary_page', (data:any) => {
		// 	if(this.modalRef){
		// 		this.modalRef.hide();
		// 	}
		// 	this.ngOnDestroy();
		// 	this.ngOnInit();
		// });

		this.socketioService.addCallback('upload_artwork', 'order_summary_page', (data:any) => {
			if(data.socket_id != this.socketioService.socket.id){	
				this.orderItems.forEach((val:any, key:any) => {
					if(val.item_id == data.data.item_id){
						this.getAttachment(this.orderItems[key], true);
					}
				});
			}
		});
	}

	setOrderValue(data:any){
		Object.keys(data).forEach((key) => {
			this.order[key] = data[key];
		});
	}

	ngOnDestroy(){
		this.socketioService.removeCallback('order_saved', 'order_summary_page');
		this.socketioService.removeCallback('upload_artwork', 'order_summary_page');
		this.socketioService.leaveOrderRoom(this.order.entity_id);
	}	

  /**
   * set the comments for status
   */

  setStatusComment() {
    let statusHistories = this.order.status_histories;

    statusHistories.forEach((status:any) => {
      let s: any = status;

      if (!this.statusComments[s.status]) {
        this.statusComments[s.status] = [];
      }
      if (s.comment) {
        if (s.comment.length > 0) {
          this.statusComments[s.status].push(s.comment);
        }
      }
    });
  }

  get classNew() {
    let o = this.orderService.order;
    let status = "";
    if (o.status == "pending" || o.status == "pending") {
      status = "pending";
    } else if (
      o.status == "artworkapproval" ||
      o.status == "waiting_for_payment" ||
      o.status == "payment_verification" ||
      o.status == "in_production" ||
      o.status == "complete"
    ) {
      status = "done";
    }

    return status;
  }

  get classArtWorkApproval() {
    let o = this.orderService.order;
    let status = "";
    if (o.status == "artworkapproval" || o.status == "processing") {
      status = "pending";
    } else if (
      o.status == "waiting_for_payment" ||
      o.status == "payment_verification" ||
      o.status == "in_production" ||
      o.status == "complete"
    ) {
      status = "done";
    }

    return status;
  }

  get classWaitingForPayment() {
    let o = this.orderService.order;
    let status = "";
    if (o.status == "waiting_for_payment") {
      status = "pending";
    } else if (
      o.status == "payment_verification" ||
      o.status == "in_production" ||
      o.status == "complete"
    ) {
      status = "done";
    }

    return status;
  }

  get classPaymentVerification() {
    let o = this.orderService.order;
    let status = "";
    if (o.status == "payment_verification") {
      status = "pending";
    } else if (o.status == "in_production" || o.status == "complete") {
      status = "done";
    }

    return status;
  }

  get classInProduction() {
    let o = this.orderService.order;
    let status = "";
    if (o.status == "in_production") {
      status = "pending";
    } else if (o.status == "complete") {
      status = "done";
    }

    return status;
  }

  get isReviewArtWork() {
    return true;
  }

	openPaymentModal(method:any, address:any) {
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				order: this.order,
				payment_method: method,
				address: address,
			},
		};

		this.modalRef = this.modalService.show(PaymentComponent, config);
		this.modalRef.setClass("payment-modal modal-dialog-centered");
		this.modalRef.content.onClose = (myData:any) => {
			this.modalRef.hide();
		};
	}

	/**
	 * open the modal for upload artwork
	 */
	uploadArtwork(item:any) {
		if(item.sku.match(/custom-t-shirt/gi)){ /**  */
			this.uploadTShirtArtWork(item);
		}
		else if(item.sku.match(/custom-canvas-tote-bag/gi)){
			this.uploadToteBagArtwork(item);
		}
		else {
			let config: ModalOptions = {
				backdrop: "static",
				keyboard: false,
				animated: true,
				ignoreBackdropClick: true,
				initialState: {
					product: item.product,
					artworkOnly: true,
					order: this.order,
					quoteId: this.orderService.order.quote_id,
					quoteItemId: item.parent_item.quote_item_id,
					item: item,
					selectedQty: item.qty_ordered,
				},
			};
	
			this.modalRef = this.modalService.show(ArtworkComponent, config);
			this.modalRef.setClass("artwork-modal modal-dialog-centered");
			this.modalRef.content.onClose = (myData:any) => {
				if(myData == "success") {
					this.modalRef.hide();
					this.ngOnInit();
				}
				else {
					this.modalRef.hide();
				}
			};
		}
	}

	uploadTShirtArtWork(item:any){
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				artworkOnly: true,
				product: item.product,
				quoteId: this.orderService.order.quote_id,
				quoteItemId: item.quote_item_id,
			}
		};
		this.modalRef = this.modalService.show(TshirtArtworkComponent, config);
		this.modalRef.setClass("t-shirt-artwork-modal artwork-modal modal-dialog-centered");
		this.modalRef.content.onClose = (myData:any) => {
			if(myData == "success") {
				this.getAttachment(item, true);
				this.modalRef.hide();
			}
			else {
				this.modalRef.hide();
			}
		};
	}

	uploadToteBagArtwork(item:any){
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				artworkOnly: true,
				product: item.product,
				quoteId: this.orderService.order.quote_id,
				quoteItemId: item.quote_item_id
			}
		};
		this.modalRef = this.modalService.show(TotebagArtworkComponent, config);
		this.modalRef.setClass("custom-canvas-tote-bag-modal artwork-modal modal-dialog-centered");
		this.modalRef.content.onClose = (myData:any) => {
			if(myData == "success") {
				this.getAttachment(item, true);
				this.modalRef.hide();
			}
			else {
				this.modalRef.hide();
			}
		};
	}

	/**
	 * get the attachment from api request
	 */
	getAttachment(item:any, activateLoader: boolean = false) {
		if (activateLoader) {
			this.productService.setLoader(true);
		}

		let attachUrl = "/rest/entrelable/V1/lns-orderattachment/attachment/" + item.parent_item.quote_item_id;
		this.productService.makeRequest(attachUrl, "", "GET").then((attach:any) => {
			item.attachments = [];
			attach.forEach((a:any) => {
				a.is_running_approval = false;
				a.is_loaded = false;

				try {
					a.others.admin_attachment.is_loaded = false;
				} catch (error) {
					/** do nothing */
				}

				item.attachments.push(a);
			});

			if (activateLoader) {
				this.productService.setLoader(false);
			}
		});
	}

  /**
   * check if all order item has an attachment or not
   */
  get attachmentChecker() {
    if (this.order) {
      // isAllItemHasAttachment
      let items = this.order.items;

      let itemCount = 0;
      let itemAttchCount = 0;
      items.forEach((item:any) => {
        if (item.parent_item) {
          itemCount++;
          if (item.attachment) {
            itemAttchCount++;
          }
        }
      });

      if (itemCount == itemAttchCount) {
        this.isAllItemHasAttachment = true;
      } else {
        this.isAllItemHasAttachment = false;
      }
    }
    return "";
  }

	reAddToCart(item:any) {

		/**
		 * we have to check if the order already have a cutting
		 * type option, this is beause cutting type is just recently been
		 * added. and old order does not have cutting option selected
		 */
		let productHasCuttingType:any = null;
		item.product.options.forEach((option:any) => {
			if(option.title == 'cutting type'){
				productHasCuttingType = option;
			}
		});

		let hasCuttingType:boolean = false;
		if(productHasCuttingType){
			item.custom_options.forEach((option:any) => {
				if(option.title == 'cutting type'){
					hasCuttingType = true;
				}
			});
		} else {
			hasCuttingType = true;
		}

		if(hasCuttingType){
			this.reAddToCartHelper(item);
		}
		else {
			/**
			 * we have to open a modal to select cutting type
			 */
			this.openPaymentModalCuttingType(item);
		}
	}

	reAddToCartHelper(item:any, custom_options: any = null) {
		this.cartService.setLoader(true);
		this.cartService.reAddToCart(item, custom_options).then((reAdd) => {
			this.cartService.toastService.add(this.lang.getLang("l104a"));
			this.cartService.setLoader(false);
			this.cartService.getCart();
		});
	}

	openPaymentModalCuttingType(item:any) {
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				item: item,
			},
		};
	
		this.modalRef = this.modalService.show(CuttingTypeComponent, config);
		this.modalRef.setClass("cutting-type-option artwork-modal modal-dialog-centered");
		this.modalRef.content.onClose = (data:any) => {
			if(data){
				this.reAddToCartHelper(item, data);
			}
		  	this.modalRef.hide();
		};
	}

  /**
   * check if there is an paymay fee
   */
  paymayaFee() {
    let result: any = 0;
    if (this.orderService.order) {
      let order = this.orderService.order;
      if (order.payment.method == "paymaya" || order.payment.method == "dragonpay") {
        let subtotal =
          order.subtotal - order.discount_amount + order.shipping_amount;
        subtotal = order.base_grand_total - subtotal;
        result = subtotal;
      }
    }
    return result;
  }

  trackToHtml(tracks:any) {
    let htmlString = "";
    if (tracks.carrier_code == "lbc" || tracks.title.toLowerCase() == "lbc") {
      htmlString +=
        '<a href="https://www.lbcexpress.com/track/' +
        tracks.hash_track +
        '" target="_blank">';
      htmlString += tracks.title + " : " + tracks.track_number;
      htmlString += "</a>";
    } else if (
      tracks.carrier_code == "lalamove" ||
      tracks.title.toLowerCase() == "lalamove"
    ) {
      htmlString +=
        '<a href="https://share.lalamove.com/?' +
        tracks.track_number +
        '&lang=en_PH" target="_blank">';
      htmlString += tracks.title + " : " + tracks.track_number;
      htmlString += "</a>";
    } else {
      htmlString += tracks.title + " : " + tracks.track_number;
    }

    return htmlString;
  }


	downloadFile(url:any, filename = 'download') {
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
  	openQuickViewArtWorkModal(item:any, attachment:any, isAdminAttach=false){

		let filename = attachment.others.filename;
		let isImage = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(filename);
		if(isAdminAttach){
			isImage = true;
		}

		if(isAdminAttach){
			if(typeof attachment.others.admin_attachment != "undefined"){
				this.quickViewImage = attachment.others.admin_attachment.firesotre_link + "";
			}
		}
		else if(isImage) {
			this.quickViewImage = attachment.google_firestore_link + "";
		}
		if(isImage) {
			let closeLayoutView = (event:any) => {
				if (event.key === 'Escape') {
					this.quickViewImage = "";
					document.removeEventListener('keydown', closeLayoutView);
				}
			}

			document.addEventListener('keydown', closeLayoutView);

			setTimeout(() => {
				let imageLazyLoad = new ImageLazyLoad();
				imageLazyLoad.init('qva-image-view', 'w-50', 'qva-image-view-loaded', () => {
					if(isAdminAttach){
						attachment.others.admin_attachment.is_loaded = true;
					}
					else {
						attachment.is_loaded = true;
					}
				});
			}, 10);
		}
		else {
			this.downloadFile(attachment.others.downloadUrl, attachment.others.filename);
		}
	}

	approveAttachment(item:any, attachment:any){
		if(!attachment.is_running_approval){
			if(!this.isApproveAttachmentConfirm){
				let config: ModalOptions = {
					backdrop: "static",
					keyboard: false,
					animated: true,
					ignoreBackdropClick: true,
				};
	
				this.modalRef = this.modalService.show(ApproveartworkComponent, config);
				this.modalRef.setClass('modal-dialog-centered modal-lg');
				this.modalRef.content.closeBtnName = 'Close';
			
				this.modalRef.content.onClose = () => {
					this.modalRef.hide();
				};
			
				this.modalRef.content.onAgree = async () => {
					this.isApproveAttachmentConfirm = true;
					attachment.is_running_approval = true;
					this.modalRef.hide();
					await this.approveArtworkHelper(item, attachment).then(approved => {
					});
					this.refreshOrder();
				}
			}
			else {
				attachment.is_running_approval = true;
				this.approveArtworkHelper(item, attachment).then(approved => {
				});
			}
		}
	}

	approveArtworkHelper(item:any, attachment:any){
		let url = '/rest/entrelable/V1/lns-orderattachment/attachment/approve/' + this.order.entity_id + '/' + attachment.id;
		return new Promise(res => {
			this.orderService.makeRequest(url, '', 'POST').then((approved:any) => {
				if(approved){
					let a: any = approved[0];
					attachment.is_running_approval = false;
					attachment.approved = a.approved;
					this.orderService.toastService.add("You've just approved the artwork", 'success');
				}
				res(approved);
			});
		});
	}

	canAddArtwork(item:any){
		let status = ['complete', 'canceled', 'closed', 'holded', 'payment_verification', 'in_production'];
		let canAdd = !status.includes(this.order.status);
		
		if(parseInt(item.qty_ordered) != 10){
			if(typeof item.attachments != 'undefined'){
				canAdd = (item.attachments.length == 0);
			}
			else {
				canAdd = true;
			}
		}

		return canAdd;
	}

	openMessageModal(item:any){

		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				order: this.order,
				quote_id: this.order.quote_id,
				qouteItemId: item.parent_item.quote_item_id,
				item: item,
			},
		};

		this.modalRef = this.modalService.show(MessageComponent, config);
		this.modalRef.setClass("modal-lg modal-dialog-scrollable modal-dialog-centered");
		this.modalRef.content.onClose = (data:any) => {
		  	this.modalRef.hide();
		};
	}

	deleteArtwork(item:any, attach:any){
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				title: "Delete Artwork",
				content: `
					<p class="mb-10">Are you sure you want to delete your artwork?</p>
					<a class="w-100-per h-100 d-block" href="${attach.google_firestore_link}" target="_blank">
						<img class="object-fit scale-down" src="${attach.google_firestore_link}">
					</a>
				`,
			},
		};

		this.modalRef = this.modalService.show(ConfirmationmodalComponent, config);
		this.modalRef.setClass('modal-dialog-centered modal-confimation');

		this.modalRef.content.onClose = () => {
			this.modalRef.hide();
		};

		this.modalRef.content.onConfirm = () => {
			this.deleteArtworkConfirmed(item, attach)
			.then(resolve => {
				this.modalRef.hide();
			})
			.catch(error => {
			});
		};
	}

	deleteArtworkConfirmed(item:any, attach:any){
		this.cartService.setLoader(true);
		return new Promise((resolve, reject) => {
			let url = '/rest/entrelable/V1/lns-orderattachment/attachment/delete/' + this.order.entity_id + '/' + item.item_id + '/'  + attach.id;
			this.orderService.doRequest(url, null, 'DELETE').then((data:any) => {
				this.cartService.setLoader(false);
				if(!data.error && data.result){
					this.cartService.toastService.add(data.result, "success");
					this.ngOnInit();
					resolve(data);
				}
				else {
					reject(data);
				}
			});
		});
	}

	openChangeOrderRequestModal(){
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: true,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				order: this.order
			},
		};

		this.modalRef = this.modalService.show(ChangeorderrequestComponent, config);
		this.modalRef.setClass('modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable');

		this.modalRef.content.onClose = () => {
			this.modalRef.hide();
		};

		this.modalRef.content.onConfirm = () => {
			this.modalRef.hide();
			this.refreshOrder()
		};
	}

	// this function serves as a reload to fetch orders, and trigger skeleton loader
	refreshOrder() {
		this.order = null;
		this.ngOnInit();
	}
}
